import { LookupItem } from "../../Shared/Models/LookupItem";
import { ClinicalSkill } from "../../Training/Models/ClinicalSkill";
import { PostGraduateYear } from "../../Training/Models/PostGraduateYear";
import { TrainingAttestation } from "../../Training/Models/TrainingAttestation";
import { MedicalEducation } from "./MedicalEducation";
import { TrainingNote } from "../../Training/Models/TrainingNote";

export default class Resident {
    constructor() {
        this.name = new ResidentName();
        this.isNewResident = true;
        this.isEditing = true;
    }

    physicianId: number;
    currentTrainingProgramId: number;
    reviewerId: number;
    isOnFastTrack: boolean;
    name: ResidentName;
    ssn4: string;
    dateOfBirth: string;
    trainingProgramId: number;
    isNewResident: boolean;
    currentPostGraduateYear: number;
    isResidentTrainingComplete: boolean;
    postGraduateYears: Array<PostGraduateYear>;
    clinicalSkills: Array<ClinicalSkill>;
    applicationStatus: ApplicationStatus;
    additionalFastTrackApplicationStatus: ApplicationStatus;
    isEditing?: boolean;
    showDetails: boolean;
    pgyLookupList: Array<LookupItem>;
    completedTrainingProgramIds: Array<number>;
    trainingAttestations: Array<TrainingAttestation>;
    trainingNotes: Array<TrainingNote>;
}

export class ResidentName {
    firstName: string;
    lastName: string;
    middleName: string;
    suffix: string;
    title: string;
    fullName: string;
    effectiveDate: string;
}


export class ResidentDetail {
    constructor(resident: Resident, medicalEducation: MedicalEducation) {
        this.physicianId = resident.physicianId;
        this.currentTrainingProgramId = resident.currentTrainingProgramId;
        this.name = resident.name;
        this.ssn4 = resident.ssn4;
        this.dateOfBirth = resident.dateOfBirth;
        this.isNewResident = resident.isNewResident;
        this.medicalEducation = medicalEducation;
    }

    physicianId: number;
    currentTrainingProgramId: number;
    name: ResidentName;
    ssn4: string;
    dateOfBirth: string;
    isNewResident: boolean;
    medicalEducation: MedicalEducation;
}

export class ApplicationStatusModel {
    applicationStatus: ApplicationStatus;
    additionalFastTrackApplicationStatus: ApplicationStatus;
}

export enum ApplicationStatus {
    Ineligable,
    Eligable,
    EligableNoExam,
    Applied,
}
